import { render, staticRenderFns } from "./PriceCatalog.vue?vue&type=template&id=541d69cb&scoped=true&"
import script from "./PriceCatalog.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceCatalog.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PriceCatalog.vue?vue&type=style&index=0&id=541d69cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541d69cb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('541d69cb')) {
      api.createRecord('541d69cb', component.options)
    } else {
      api.reload('541d69cb', component.options)
    }
    module.hot.accept("./PriceCatalog.vue?vue&type=template&id=541d69cb&scoped=true&", function () {
      api.rerender('541d69cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceCatalog/PriceCatalog.vue"
export default component.exports